import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import FeatureItem from './FeatureItem'
import { breakpoints, theme } from '../builderUtils/theme'

const FeaturesSection = styled.section`
  overflow: hidden;
  padding: 2.5rem 6rem 5rem;
  font-family: 'MatterRegular';
  text-align: center;
  color: ${theme.black};
  background-color: ${theme.cream};

  @media (max-width: ${breakpoints.m}px) {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
`

const FeaturesContainer = styled.div`
  width: 100%;

  @media (max-width: ${breakpoints.m}px) {
    max-width: 100%;
  }
`

const FeaturesTitle = styled.h2`
  font-family: 'MatterRegular';
  font-size: 2.25rem;
  font-weight: 700;
  color: ${theme.black};

  @media (max-width: ${breakpoints.m}px) {
    max-width: 100%;
  }
`

const FeaturesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2.5rem;
  align-items: flex-end;
  margin-top: 2.75rem;
  width: 100%;
  font-size: 1.5rem;

  @media (max-width: ${breakpoints.m}px) {
    margin-top: 2.5rem;
    max-width: 100%;
    max-height: 700px;
    overflow: scroll;
  }
`

export default function FeaturesBlock({ sectionTitle, featureItems }) {
  // eslint-disable-next-line react/destructuring-assignment
  const displayedFeatures = featureItems.length > 6 ? featureItems.slice(0, 6) : featureItems

  return (
    <FeaturesSection>
      <FeaturesContainer>
        <FeaturesTitle>{sectionTitle}</FeaturesTitle>
        <FeaturesGrid>
          {displayedFeatures.map((feature, idx) => {
            const { image, title, description, alt } = feature
            const displayAlt = alt || title
            return (
              <FeatureItem
                key={`${idx}-${title}`}
                image={image}
                title={title}
                alt={displayAlt}
                description={description}
              />
            )
          })}
        </FeaturesGrid>
      </FeaturesContainer>
    </FeaturesSection>
  )
}

FeaturesBlock.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  featureItems: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      alt: PropTypes.string,
    })
  ),
}
